import { fork, call, put, all, takeEvery } from "redux-saga/effects";
import asyncInterface from "../../../../asyncInterface";
import * as actionTypes from './actionTypes'

export function fetchAccountData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.investmentDashboard.fetchAccountData(fetchPayload);
}
export function* investmentDataFetch(data) {
  yield put({
    type:actionTypes.investmentDashboardDataLoaderType,
    payload: ''
  });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.investmentDashboardDataSuccessType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: actionTypes.accountDataRequestFailedType,
      error
    });
  }
}
export function* recentDataFetch(data) {
  yield put({
    type: actionTypes.recentExchangeDataLoaderType,
    payload: ''
  });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.recentExchangeDataSuccessType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: actionTypes.recentDataRequestFailedType,
      error
    });
  }
}
export function* recurringDataFetch(data) {
  yield put({
    type: actionTypes.recurringExchangeDataLoaderType,
    payload: ''
  });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.recurringExchangeDataSucessType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: actionTypes.recurringDataRequestFailedType,
      error
    });
  }
}
export function* fetchAccountDataWorker(fetchPayload) {
  yield all([
    fork(investmentDataFetch, fetchPayload.payload.metaData[0]),
    fork(recentDataFetch, fetchPayload.payload.metaData[1]),
    fork(recurringDataFetch, fetchPayload.payload.metaData[2])
  ]);
}

export function* fetchInvestmentDashboardDataWatcher() {
  yield takeEvery(actionTypes.investmentDashboardSuccessType, fetchAccountDataWorker);
}

export default function* commonSagaWatcher() {
  yield all([fork(fetchInvestmentDashboardDataWatcher)]);
}
